module.exports = __webpack_public_path__ + "static/flags/CO-b63814eb004843f22e431d1a554c1bf6.gif";